/**
 * A class for composing SQL queries.
 */
export class SqlComposer {
    /**
     * Creates 'ORDER BY' statement
     * @param {string[]} columns - An array of columns to order by.
     * @returns {string} - An 'ORDER BY' statement. Returns an empty string if the input array is empty or all items are empty.
     */
    static ORDER_BY(columns: string[]): string {
        const orderBy = columns.filter((col) => col).join(', ');
        return orderBy ? `ORDER BY ${orderBy}` : '';
    }

    /**
     * Creates 'GROUP BY' statement
     * @param {string[]} columns - An array of columns to group by.
     * @returns {string} - A 'GROUP BY' statement. Returns an empty string if the input array is empty or all items are empty.
     */
    static GROUP_BY(columns: string[]): string {
        const groupBy = columns.filter((col) => col).join(', ');
        return groupBy ? `GROUP BY ${groupBy}` : '';
    }

    /**
     * Creates a prefix for a column name
     * @param {string} prefix - A prefix to add to the column name.
     * @param {string} column - A column name.
     * @returns {string} - A prefixed column name. Returns an empty string if the column name is empty.
     */
    static Prefix(prefix: string, column: string): string {
        return column ? `${prefix}.${column}` : '';
    }

    /**
     * Creates 'SELECT' statement
     * @param {string[]} columns - An array of columns to select.
     * @returns {string} - A 'SELECT' statement. Returns an empty string if the input array is empty or all items are empty.
     */
    static SELECT(columns: string[]): string {
        const select = columns.filter((col) => col).join(',\n  ');
        return select ? `SELECT ${select}` : '';
    }
}
